import ReassignsTable from './ReassignsTable';

export default ReassignsTable;
